import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const Search = ({ valueSearch, handleChange, changeIconOut, placeholder }) => (
  <div className="Search">
    <input
      type="search"
      className="content-search"
      placeholder={placeholder}
      value={valueSearch}
      onChange={handleChange}
    />
    <span className="icon-search" role="button" tabIndex="0" onClick={changeIconOut} />
  </div>
);

Search.propTypes = {
  valueSearch: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default Search;
